export const name = "KLL_QUANTILES.EXTRACT_POINT_FLOAT64";
export const summary = `Gets a specific quantile from a \`FLOAT64\`-initialized KLL sketch.`;
export const reference = `
## KLL_QUANTILES.EXTRACT_POINT_FLOAT64

Gets a specific quantile from a \`FLOAT64\`-initialized KLL sketch.

\`\`\`
KLL_QUANTILES.EXTRACT_POINT_FLOAT64(sketch, phi)
\`\`\`

### Description

Like \`KLL_QUANTILES.EXTRACT_POINT_INT64\`, but accepts KLL sketches initialized on data of type\`FLOAT64\`.


### Supported Argument Types

- \`sketch\`: \`BYTES\` KLL sketch initialized on\`FLOAT64\` data type
- \`phi\`: \`FLOAT64\` between 0 and 1


### Return Type

\`FLOAT64\`


source: https://cloud.google.com/bigquery/docs/reference/standard-sql/kll_functions
`;
